/*
 * MOBILE-MATERIALS.API.JS - API layer for Mobile Visible Materials
 *
 * SUMMARY:
 * Uses the shared axios wrapper and microServices routing to
 * fetch and update the curated list of visible materials.
 */

import axios, { microServices } from './axios'

const GET_VISIBLE_MATERIALS = '/mobile/materials'
const SET_VISIBLE_IDS = '/mobile/materials'

/**
 * Fetches mobile visible materials with full item details
 * @returns {Promise<{ids: string[], materials: Object[]}>}
 */
export const getMobileVisibleMaterialsAPI = async () => {
    return await axios('get', GET_VISIBLE_MATERIALS, {}, { server: microServices.DE_CORE })
        .then(data => { return data }, error => {
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
}

export const setMobileVisibleMaterialIdsAPI = async (ids) => {
    return await axios('put', SET_VISIBLE_IDS, { ids }, { server: microServices.DE_CORE })
        .then(data => { return data }, error => {
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
}


